<template>
  <div class="bg">
      <img src="@/assets/kefu/cuccLog.jpg" alt="" class="imgs">
      <!-- <div class="pulse1"></div>
      <div class="pulse2"></div>
      <div class="pulse3"></div> -->
      <!-- <img src="../assets/img/txt-tips-open.png" alt=""> -->
  </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods:{
        goluckywheel() {
            window.location.href = 'http://webchat.szxxtx.com/#/luckywheel'
        }
    }
}
</script>

<style lang="less" scoped>
.imgs{
    width: 100%;
    height: 100%;
   
}

@keyframes changeright {
    0% {
        -webkit-transform: rotate(0deg);
    }
    25% {
        -webkit-transform: rotate(90deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
    }
    75% {
        -webkit-transform: rotate(270deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

// div[class^="pulse"] {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%,-50%);
//     width: 128px;
//     height: 128px;
//     box-shadow: 0 0 30px #ff9900;
//     border-radius: 50%;
//     animation: pluse 1.5s linear infinite;
// }

// .bg div.pulse2 {
//     animation-delay: 0.5s;
// }

// .bg div.pulse3 {
//     animation-delay: 1s;
// }

// @keyframes pluse {
//     0% {}
//     20% {
//         width: 135px;
//         height: 135px;
//         opacity: .3;
//     }
//     40% {
//         width: 150px;
//         height: 150px;
//         opacity: .5;
//     }
//     60% {
//         width: 150px;
//         height: 150px;
//         opacity: .7;
//     }
//     80% {
//         width: 165px;
//         height: 165px;
//         opacity: .8;
//     }
//     80% {
//         width: 170px;
//         height: 170px;
//         opacity: .5;
//     }
// }
</style>